$bog_builderui_progress $mol_view
	dom_name \progress
	value 50
	max 100
	attr *
		^
		value <= value 50
		max <= max 100
